import React from 'react'
import { Button } from '@material-ui/core';


export default class SiteMap extends React.Component {
    render(){
        return(
       <div style={{width:'fit-content', 
                    position:'relative', 
                    marginLeft:50,  
                    display:'inline-block',
                    marginTop:15, 
                    textAlign:'left' }}>
            <div>
            <Button onClick={()=>{this.props.buttonSelected(this.props.b.id)}} style={{ 
                                                                                    position:'relative',
                                                                                    borderRadius:25,
                                                                                    fontWeight:600, 
                                                                                    borderTopLeftRadius:0,
                                                                                    borderBottomLeftRadius:0,
                                                                                    backgroundColor:this.props.b.color, 
                                                                                    width:'fit-content', 
                                                                                    color:'white',
                                                                                    borderColor:'transparent' }} 
                                
                                variant="outlined">{this.props.b.label}</Button>

                                     <div style={{                         
                                                    width: 0,
                                                    height: 0,
                                                    borderTop: '15px solid transparent',
                                                    borderBottom: '15px solid transparent', 
                                                    borderLeft:`36px solid ${this.props.b.color}`, 
                                                     position:'absolute',
                                            top:3,
                                            right:-39
                                                  
                                                    
                                                }}>

                                </div>
                              

            </div>
       
    
               

                </div>
       
            )
        
    }
  
}